// Central SEO config — used by <Seo /> to set per-route meta tags via react-helmet-async.
export const SITE = {
  name: "Apexture",
  url: "https://apexture.com",
  defaultTitle: "Apexture — Fix Your Posture at Home | AI Physiotherapy",
  defaultDescription:
    "Fix forward head, rounded shoulders, hunched back and back pain from home. AI-powered posture check + a personalized 4-step exercise plan in 15 minutes. ₹199 for 3-month access.",
  keywords: [
    "posture correction app",
    "fix bad posture at home",
    "online physiotherapy India",
    "forward head posture fix",
    "rounded shoulders exercises",
    "hunched back correction",
    "back pain relief exercises",
    "posture assessment app",
    "AI physiotherapy consultation",
    "desk worker posture fix",
    "kyphosis correction exercises",
    "lordosis exercises",
    "flat feet exercises",
    "muscular imbalance test",
    "at home physio exercises",
  ],
  ogImage: "/og-image.png",
  twitterHandle: "@apexture",
};

// Per-route SEO overrides. Match by pathname.
export const ROUTE_SEO = {
  "/": {
    title: "Apexture — Fix Your Posture at Home | AI Physiotherapy",
    description:
      "AI-powered posture assessment + a personalized 4-step home exercise plan to fix forward head, rounded shoulders, hunched back and back pain. Just ₹199 for 3-month access.",
  },
  "/assessment": {
    title: "Free Posture Check — AI or Pick-a-Picture | Apexture",
    description:
      "Snap a side-view photo, use your webcam, or just pick the picture that looks like your posture. Get an instant AI analysis in under a minute.",
  },
  "/safety-screen": {
    title: "Safety Screen — Should You See a Doctor First? | Apexture",
    description:
      "Quick 30-second safety check before you start any posture exercises. We flag any red-flag symptoms that need a medical visit first.",
  },
  "/posture-pattern": {
    title: "Your Posture Pattern Result | Apexture",
    description:
      "Which of the 8 common posture patterns matches you — forward head, rounded shoulders, kyphosis, lordosis, sway back, flat back, scoliosis, or foot pronation.",
  },
  "/muscular-assessment": {
    title: "Muscular Imbalance Self-Test | Apexture",
    description:
      "Test 29 muscle groups at home with clear picture guides — find the exact tight, weak or knotted muscles behind your posture problem.",
  },
  "/pricing": {
    title: "Pricing — ₹199 for 3-Month Access | Apexture",
    description:
      "Full posture assessment, personalized 4-phase plan, curated exercise videos, and progress tracking. Just ₹199 for 3 months. 7-day refund policy.",
  },
  "/feedback": {
    title: "Feedback & Grievance | Apexture",
    description:
      "Share feedback, report a bug, or raise a grievance. We respond within 15 business days as required by IT Rules 2021.",
  },
  "/terms": { title: "Terms of Service | Apexture" },
  "/privacy": { title: "Privacy Policy | Apexture" },
  "/refund": { title: "Refund Policy | Apexture" },
  "/disclaimer": { title: "Medical Disclaimer | Apexture" },
};
